export default __webpack_public_path__ + "static/media/complete.b7cd5d55.svg";